import { Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import { styles } from "./BasketView.styles";
import unzer from "../../utilities/unzer";
import * as CreditCardAction from "../../stores/payment/CreditCardAction";
import { useDispatch, useSelector } from "react-redux";
import configuration from "../../utilities/configuration";

export interface ICreditCardPaymentProps extends WithStyles<typeof styles> {
    customerName: string,
    checkoutEnabled: boolean,
    setCardError: any,
    cardError: any,
    checkCardValidity: boolean,
    setCreditCardValidId: any,
    setCheckCardValidity: any,
    creditCardValidId: string
}

const CreditCardPaymentPure: React.FunctionComponent<ICreditCardPaymentProps> = ({classes, customerName, checkoutEnabled, setCardError, cardError, checkCardValidity, setCreditCardValidId, setCheckCardValidity, creditCardValidId}: ICreditCardPaymentProps) => {

    const dispatch = useDispatch();

    const basket = useSelector((state) => state.basket);

    let unzerInstance = React.useRef(null);
    let unzerCard = React.useRef(null);
    let cardId = "";

    const nameArray = customerName.split(" ");
    const customerData = JSON.stringify({"firstname": String(nameArray[0]), "lastname": String(nameArray[nameArray.length - 1])});    

    React.useEffect(() => {
        dispatch(CreditCardAction.creditCardCustomer(customerData));
        unzerInstance.current = new unzer(configuration.paymentCustomerAuth, {locale: 'en-US'}); //to enable auto locale, change to: {locale: 'auto'}
        unzerCard.current = unzerInstance.current.Card();
        unzerCard.current.create('number', {containerId: 'card-element-id-number', onlyIframe: false});
        unzerCard.current.create('expiry', {containerId: 'card-element-id-expiry', onlyIframe: false});
        unzerCard.current.create('cvc', {containerId: 'card-element-id-cvc', onlyIframe: false});
        unzerCard.current.create('3ds', "true");
    }, [customerData, dispatch]);

    const customerId = useSelector((state) => state.payment.customer?.id);
    const redirect3ds = useSelector((state) => state.payment.charge?.redirectUrl);
    const paymentId = useSelector((state) => state.payment.charge?.resources.paymentId);

    if (paymentId) {
        localStorage.setItem("paymentId", paymentId);
        //if the connection to the charge payment was successfull, the url to 3ds verification is transmitted back and therefore can be opened in a new window
        if (redirect3ds) {
            window.open(redirect3ds, "_self");
        };
    };

    useEffect(() => {
        if (checkoutEnabled) {
            const returnUrl = String(window.location.origin) + "/basket-status/" + String(basket.orderId);

            const paymentData = {
                "currency": "EUR",
                "returnUrl": String(returnUrl),
                "cardHolder": String(customerName),
                "customerId": String(customerId),
                "cardId": String(creditCardValidId),
                "orderId": Number(basket.orderId)
            };

            dispatch(CreditCardAction.creditCardPayment(paymentData)); //charge the credit card
           
        };
    }, [basket.orderId, checkoutEnabled, creditCardValidId, customerId, customerName, dispatch]);

    if (checkCardValidity && unzerCard.current) {
        //check if the credit card is valid
        const successHandler = function(data) {
            setCardError(null);
            cardId = data.id;
            //in case the credit card was successfully created, the payment will be submitted
            setCreditCardValidId(cardId);
        };

        const errorHandler = function(error) {
            setCardError(error.message); //error.merchantMessage
            setCreditCardValidId(null);
        };

        unzerCard.current.createResource()
            .then(successHandler)
            .catch(errorHandler);
            
        setCheckCardValidity(false);
    };

    return <>
        <div className="container" style={{width: "100%"}}>
            {cardError
                ? <Typography className={classes.paymentError}>{cardError}</Typography>
                : null
            }
            <form id="payment-form" className="unzerUI form" noValidate>
                <div className="wide field">
                    <div id="card-element-id-number" className="unzerInput"></div>
                </div>
                <div className="two fields">
                    <div className="field ten wide">
                        <div id="card-element-id-expiry" className="unzerInput"></div>
                    </div>
                    <div className="field six wide">
                        <div id="card-element-id-cvc" className="unzerInput"></div>
                    </div>
                </div>
            </form>
        </div>
    </>
};

export const CreditCardPayment = withStyles(styles)(CreditCardPaymentPure);